import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Select, type SelectProps } from '@frontend/legacy-components';

import { paymentTermsDrawer } from './data/actions';
import { getPaymentTerms } from './data/reducer';

const NEW_PAYMENT_TERMS = 'NEW_PAYMENT_TERMS';
type PaymentTerm = {
  id: string;
  label: string;
};

type PaymentTermsOption = {
  label: string;
  value: string;
};
export type PaymentTermsSelectProps = Omit<
  SelectProps,
  'value' | 'onChange'
> & {
  value?: string; // paymentTerms id or NEW_PAYMENT_TERMS
  setValue: (value?: string) => void;
};

export const PaymentTermsSelect = ({
  setValue,
  value,
  ...props
}: PaymentTermsSelectProps) => {
  const dispatch = useDispatch();

  const paymentTerms: PaymentTerm[] = useSelector(getPaymentTerms);
  const paymentTermsOptions = [
    {
      label: 'Add new payment terms',
      value: NEW_PAYMENT_TERMS,
    },
  ].concat(
    paymentTerms
      ? paymentTerms.map(({ label, id }) => ({
          label,
          value: id,
        }))
      : [],
  );

  const openPaymentTermsDrawer = useCallback(
    (payload: { cb: (value: string) => void }) => {
      dispatch(paymentTermsDrawer.open(payload));
    },
    [dispatch],
  );

  return (
    <Select
      isClearable={false}
      options={paymentTermsOptions}
      placeholder=""
      value={paymentTermsOptions.find((p) => p.value === value)}
      {...props}
      onChange={(option: PaymentTermsOption | null) => {
        const value = option?.value ?? '';
        if (value === NEW_PAYMENT_TERMS) {
          openPaymentTermsDrawer({
            cb: (newValue: string) => {
              setValue(newValue);
            },
          });
        } else {
          setValue(value);
        }
      }}
    />
  );
};
